// Admin copy of the web app's src/device/RequireFunction.jsx (card 540f21a4); keep the two in step.
// A screen on an event-day device opens only when the device's job includes
// it (card 540f21a4); otherwise the device goes back to its home. The server
// refuses anything outside the job anyway — this keeps the screens honest.
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useJobDevice } from './DeviceContext';

export default function RequireFunction({ any, children }) {
  const { me, can } = useJobDevice();
  if (!me) return null; // the job is still loading
  return can(...any) ? children : <Navigate to="/" replace />;
}
